import React from 'react';
/* eslint-disable-next-line */

export function DrawerContent(props: any) {
    return (
        <div className="drawer-content">
            {props.children}
        </div>
    );
}

